import React, { useState, useEffect, useContext, useRef } from 'react';
import './SHEventInfoPage.css';
import { TbMapPin } from 'react-icons/tb';
import SHEventDetail from './views/SHEventDetail';
import SHEventReceipt from './views/SHEventReceipt';
import SHEventInfoPageHeader from '../../components/SHEventInfoPageHeader/SHEventInfoPageHeader';
import { useLanguage } from '../../../../LanguageProvider';
import SHEventSpeakers from './views/SHEventSpeakers';
import SHEventSponsors from './views/SHEventSponsors';
import SHEventTickets from './views/SHEventTickets';
import SHEventPayment from './views/SHEventPayment';
import Services from '../../../../services/Services';
import { useToaster } from '../../../../ToasterProvider';
import { GeneralContext } from '../../../../GeneralProvider';
import SHEventInfoBox from './views/SHEventInfoBox';
import SHEventCommentBox from './views/SHEventCommentBox';
import AlertBox from '../../../../components/AlertBox/AlertBox';
import SHEventSoldTickets from './views/SHEventSoldTickets';
import SHEventMyTickets from './views/SHEventMyTickets';
import SHEventETicket from './views/SHEventETicket';
import SHEventSettings from './views/SHEventSettings';
import SHEventBulkTicketEntry from './views/SHEventBulkTicketEntry';

export default function SHEventInfoPage({ event, setSelectedEvent, isAdmin, channelTitle, channelLogo, getEvents, handleChannelChange }) {
    const { eventUriTab, eventIDUri, setCreateProjectLoading, myChannels, handleJoinChannel, userId, buildUserDetails, sendEventVisit } = useContext(GeneralContext);
    const token = localStorage.getItem("token")
    const { toastError } = useToaster();
    const { getTranslation } = useLanguage();
    const [tickets, setTickets] = useState({});
    const initialTabText = getTranslation(eventUriTab ?? 'details');
    const [activeTab, setActiveTab] = useState(initialTabText);
    const [showReceipt, setShowReceipt] = useState(false);
    const [eventDetails, setEventDetails] = useState();
    const [subTotalPrice, setSubTotalPrice] = useState();
    const [remainingTickets, setRemainingTickets] = useState();
    const [showSureModal, setShowSureModal] = useState(false);
    const [showSuccesModal, setShowSuccesModal] = useState(false);
    const [isMultiple, setIsMultiple] = useState(false);
    const [myTickets, setMyTickets] = useState([]);
    const prevTabRef = useRef(null);
    const [participantCount, setParticipantCount] = useState(0);

    let showTickets =
        (!Array.isArray(eventDetails?.tickets) ? false : eventDetails?.tickets.length > 0) &&
        event?.hasTickets === "1" &&
        Date.now() >= (Number(eventDetails?.ticketSaleStartDateTime) * 1000) &&
        Date.now() <= (Number(eventDetails?.eventEndDateTime) * 1000);

    let tabs = [
        getTranslation('details'),
        getTranslation('tickets'),
        getTranslation('myTickets')
    ];

    if (isAdmin === "1") {
        tabs = [
            getTranslation('details'),
            getTranslation('tickets'),
            getTranslation('myTickets'),
            getTranslation('soldTickets'),
            getTranslation('bulkTicketEntry'),
            getTranslation('settings')
        ];
    }

    else {

        if (showTickets) {
            tabs = [
                getTranslation('details'),
                getTranslation('tickets'),
                getTranslation('myTickets')
            ];
        }

        else {
            tabs = [
                getTranslation('details'),
                getTranslation('myTickets')
            ];
        }
    }

    const reserveFlowRef = useRef({
        started: false,
        targetChannelID: null,
        switchedOnce: false
    });

    // üst kısımda, component içinde
    const tabKeyMap = {
        [getTranslation('details')]: "details",
        [getTranslation('tickets')]: "tickets",
        [getTranslation('myTickets')]: "mytickets",
        [getTranslation('soldTickets')]: "soldtickets",
        [getTranslation('bulkTicketEntry')]: "bulkticketentry",
        [getTranslation('settings')]: "settings",
        [getTranslation('speakers')]: "speakers",
        [getTranslation('sponsors')]: "sponsors",
        payment: "payment"
    };

    const normalizeTab = (tab) => tabKeyMap[tab] || String(tab).toLowerCase();

    useEffect(() => {
        if (!event?.eventID || !event?.channelID || !activeTab) return;

        // Sadece ilk render’da tek seferlik "enter" log’u
        if (prevTabRef.current === null) {
            const details = buildUserDetails(false, {
                fromTab: null,
                toTab: normalizeTab(activeTab),
            });
            sendEventVisit(event.channelID, event.eventID, details);
            prevTabRef.current = activeTab;
        }
    }, [event?.eventID, activeTab]);

    const _setActiveTab = (nextTab) => {
        const from = prevTabRef.current ?? normalizeTab(activeTab);
        const to = nextTab;

        setActiveTab(nextTab);

        if (event?.eventID && event?.channelID) {
            const details = buildUserDetails(true, {
                fromTab: normalizeTab(from),
                toTab: normalizeTab(to),
            });
            sendEventVisit(event.channelID, event.eventID, details);
        }
        prevTabRef.current = to;
    };

    const toId = (v) => (v == null ? null : String(v));

    const handleReserveSpot = () => {
        const eventChId = toId(event?.channelID);
        if (!eventChId) return;

        reserveFlowRef.current.started = true;
        reserveFlowRef.current.targetChannelID = eventChId;
        reserveFlowRef.current.switchedOnce = false;

        if (!Array.isArray(myChannels) || myChannels.length === 0) {
            handleJoinChannel(eventChId);
            return;
        }

        const channelIDs = myChannels
            .map((ch) => toId(ch?.channelID ?? ch?.id ?? null))
            .filter(Boolean);

        if (!channelIDs.includes(eventChId)) {
            handleJoinChannel(eventChId);
        }
    };

    useEffect(() => {
        const { started, targetChannelID, switchedOnce } = reserveFlowRef.current;
        if (!started || !targetChannelID || switchedOnce) return;

        const newChannel = Array.isArray(myChannels)
            ? myChannels.find((x) => toId(x?.channelID) === targetChannelID || toId(x?.id) === targetChannelID)
            : undefined;

        if (newChannel) {
            handleChannelChange?.(newChannel, true);
            reserveFlowRef.current.switchedOnce = true;
        }
    }, [myChannels, handleChannelChange]);

    const getEventDetails = () => {
        Services.SocialHiveGetEventDetails(token, event.eventID)
            .then((res) => {
                if (res.data.status) {
                    const currentTickets = res.data.result.tickets || [];

                    const isFree = currentTickets.every(t => Number(t.price) === 0)
                        ? "1"
                        : currentTickets.every(t => Number(t.price) > 0)
                            ? "2"
                            : "3";

                    Services.SocialHiveUpdateEvent(token, { channelID: event.channelID, eventID: event.eventID, isFree })
                        .then((res) => {
                            getEvents()
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                    setEventDetails(res.data.result)
                    setRemainingTickets(calculateRemainingTickets(res.data.result))
                } else {
                    toastError(res.data.message || getTranslation("somethingWentWrong"));
                }
            })
            .catch((err) => {
                console.error(err);
                toastError(getTranslation("somethingWentWrong"));
            });
    }

    useEffect(() => {
        if (!eventDetails?.eventID || !userId) return;
        Services.SocialHiveGetEventMyTickets(token, eventDetails.eventID, userId)
            .then((res) => {
                if (res.data.status) setMyTickets(res.data.result);
                else setMyTickets([]);
            })
            .catch((err) => console.error(err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventDetails?.eventID, userId, token]);

    useEffect(() => {
        getEventDetails()

    }, [event.eventID]);

    // Open Graph meta tags for event sharing
    useEffect(() => {
        if (!event?.eventID) return;

        const baseUrl = window.location.origin;
        const eventUrl = `${baseUrl}/event/${event.eventID}/details`;
        const ogImageUrl = `${baseUrl}/opengraph-image-events.jpg`;
        
        // Get event title and description (prefer eventDetails if available, fallback to event)
        const eventTitle = eventDetails?.title || event?.title || 'Lodos Events';
        const eventDescription = eventDetails?.description || event?.description || 'Join us for this exciting event!';
        
        // Strip HTML tags from description for meta tag
        const plainDescription = eventDescription.replace(/<[^>]*>/g, '').substring(0, 200);

        // Create or update Open Graph meta tags
        const metaTags = [
            { property: 'og:title', content: eventTitle },
            { property: 'og:description', content: plainDescription },
            { property: 'og:image', content: ogImageUrl },
            { property: 'og:url', content: eventUrl },
            { property: 'og:type', content: 'website' },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: eventTitle },
            { name: 'twitter:description', content: plainDescription },
            { name: 'twitter:image', content: ogImageUrl },
        ];

        // Remove existing OG tags first
        const existingTags = document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]');
        existingTags.forEach(tag => tag.remove());

        // Add new meta tags
        metaTags.forEach(({ property, name, content }) => {
            const meta = document.createElement('meta');
            if (property) {
                meta.setAttribute('property', property);
            }
            if (name) {
                meta.setAttribute('name', name);
            }
            meta.setAttribute('content', content);
            document.head.appendChild(meta);
        });

        // Debug: Log OG tags in development
        if (process.env.NODE_ENV === 'development') {
            // console.log('🔍 Open Graph Tags Set:', {
            //     'og:title': eventTitle,
            //     'og:description': plainDescription.substring(0, 50) + '...',
            //     'og:image': ogImageUrl,
            //     'og:url': eventUrl,
            // });
        }

        // Cleanup function
        return () => {
            const tagsToRemove = document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]');
            tagsToRemove.forEach(tag => tag.remove());
        };
    }, [event?.eventID, eventDetails?.title, eventDetails?.description, event?.title, event?.description]);


    const handleTicketChange = (typeId, infos) => {
        setTickets(prevTickets => {
            const updatedTickets = { ...prevTickets, [typeId]: infos };
            setShowReceipt(Object.values(updatedTickets).some(arr => arr.length > 0));
            return updatedTickets;
        });
    };

    useEffect(() => {
        if (eventDetails && eventDetails.tickets) {
            const initTickets = {};
            eventDetails.tickets.forEach(type => {
                initTickets[type.ticketID] = [];
            });
            setTickets(initTickets);
        }
    }, [eventDetails]);

    const handleCheckoutClicked = (price) => {
        const all = Object.values(tickets).flat();
        const hasEmptyInfo = all.some(ticket =>
            !ticket.name || !ticket.lastname || !ticket.email || !ticket.phone
        );

        if (hasEmptyInfo) {
            setActiveTab(getTranslation('tickets'));
            return;
        }
        setSubTotalPrice(price);

        if (price > 0) {
            setActiveTab('payment');
        }
        else {
            if (all.length > 1) {
                setIsMultiple(true)
            }
            else {
                setIsMultiple(false)
            }
            setShowSureModal(true)
        }
    };

    const completeFreeTicketsPurchase = () => {
        setCreateProjectLoading(true)
        const all = Object.values(tickets).flat();
        all.forEach(ticket => {
            Services.SocialHiveCreateSoldTicket(
                token,
                ticket.channelID,
                ticket.eventID,
                ticket.ticketID,
                "free",
                ticket.name,
                ticket.lastname,
                ticket.email,
                ticket.phone,
                true,
                {}
            )
                .then(response => {
                    if (response.data.result) {
                        setShowSureModal(false)
                        setTickets({})
                        setShowReceipt(false)
                        setShowSuccesModal(true)
                    }
                    else {

                    }
                    setCreateProjectLoading(false)

                })
                .catch(err => {
                    console.error("CreateSoldTicket error", err);
                });
        });
    }

    function calculateRemainingTickets(eventDetails) {

        if (!eventDetails?.tickets || !Array.isArray(eventDetails.tickets)) {
            return;
        }

        const totalTickets = eventDetails.tickets.reduce((sum, ticket) => {
            if (ticket.trackInventory === "1") {
                return sum + Number(ticket.inventory || 0);
            }
            return sum;
        }, 0);

        const totalSold = eventDetails.tickets.reduce((sum, ticket) => {
            if (ticket.trackInventory === "1") {
                return sum + Number(ticket.soldInventory || 0);
            }
            return sum;
        }, 0);

        const remainingTickets = totalTickets - totalSold;

        return remainingTickets;
    }

    const getSoldTicketListCount = () => {
        Services.SocialHiveGetEventSoldTickets(token, eventDetails?.eventID)
            .then((res) => {
                setParticipantCount(res?.data?.result.length)
            })
            .catch((err) => {
                console.error(err);
            });

    };

    useEffect(() => {
        getSoldTicketListCount()
    }, [eventDetails]);

    return (
        <>
            <SHEventInfoPageHeader
                activeTab={activeTab}
                setActiveTab={_setActiveTab}
                tabs={tabs}
                setSelectedEvent={setSelectedEvent}
                event={event}
            />

            <div className="sh-info-container">
                {(activeTab === getTranslation('details')) && <SHEventDetail event={eventDetails} isAdmin={isAdmin} getEventDetails={getEventDetails} activeTab={activeTab} />}
                {activeTab === getTranslation('speakers') && <SHEventSpeakers isAdmin={isAdmin} event={eventDetails} getEventDetails={getEventDetails} />}
                {activeTab === getTranslation('tickets') && !!eventDetails && (
                    <SHEventTickets
                        isAdmin={isAdmin}
                        event={eventDetails}
                        ticketTypes={eventDetails?.tickets ? eventDetails?.tickets : []}
                        ticketInfosMap={tickets}
                        handleTicketChange={handleTicketChange}
                        getEventDetails={getEventDetails}
                        getEvents={getEvents}
                        handleReserveSpot={handleReserveSpot}
                    />
                )}

                {activeTab === getTranslation('soldTickets') && (
                    <SHEventSoldTickets event={eventDetails} />
                )}
                {activeTab === getTranslation('myTickets') && (
                    <SHEventMyTickets event={eventDetails} />
                )}
                {activeTab === getTranslation('bulkTicketEntry') && (
                    <SHEventBulkTicketEntry event={eventDetails} />
                )}
                {activeTab === getTranslation('sponsors') && <SHEventSponsors isAdmin={isAdmin} event={eventDetails} getEventDetails={getEventDetails} />}
                {activeTab === getTranslation('settings') && <SHEventSettings event={eventDetails} getEventDetails={getEventDetails} />}

                {activeTab === "payment" && <SHEventPayment tickets={tickets} subTotal={subTotalPrice} setActiveTab={setActiveTab} />}

                {(activeTab !== getTranslation('soldTickets') && activeTab !== getTranslation('myTickets') && activeTab !== getTranslation('settings')) && activeTab !== getTranslation('bulkTicketEntry') &&
                    <div className="sh-info-aside">
                        <SHEventInfoBox event={event} channelTitle={channelTitle} channelLogo={channelLogo} participantCount={participantCount} />

                        {(showReceipt || activeTab === getTranslation('tickets')) && !!eventDetails ? (
                            <SHEventReceipt ticketInfosMap={tickets} event={eventDetails} tickets={tickets} handleCheckoutClicked={handleCheckoutClicked} activeTab={activeTab} />
                        ) : <>

                            {showTickets &&
                                <div className="sh-info-description">
                                    <span className='sh-speakers-title'>{getTranslation('signup')}</span>

                                    {(eventDetails?.settings && eventDetails?.settings.showParticipantCount) &&
                                        <div style={{ marginTop: '3px' }}>
                                            <strong>{getTranslation("participantCount")}: </strong>
                                            <span className="sh-event-time">{participantCount}</span>
                                        </div>
                                    }


                                    <div className='sh-event-time' style={{ fontSize: '16px', fontWeight: '500', marginTop: '5px' }}>
                                        {getTranslation('joinEventInvitation')}
                                    </div>

                                    <button
                                        onClick={() => { setActiveTab(getTranslation('tickets')); }}
                                        className="sh-settings-action-button"
                                        style={{
                                            alignSelf: 'auto',
                                            height: '38px',
                                            maxHeight: '38px',

                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            paddingInline: '5px',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            marginBottom: '15px',
                                            width: '100%',
                                            display: 'flex',
                                            gap: '10px'
                                        }}
                                    >
                                        {myTickets.length === 0 ? getTranslation("reserveYourSpot") : getTranslation("getMoreTickets")}
                                    </button>
                                </div>
                            }
                        </>
                        }

                        {(eventDetails?.settings && eventDetails?.settings.showTicketsOnSale) &&
                            <>
                                {(showTickets) ?
                                    <>
                                        {remainingTickets > 0 ?
                                            <>
                                                {(eventDetails?.settings && eventDetails?.settings.warnOnLowTickets && remainingTickets <= eventDetails?.settings.warnThreshold) ?
                                                    <div className="sh-info-description blink-border">
                                                        <div className='sh-event-time' style={{ fontSize: '16px', fontWeight: '500', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                                                            {getTranslation('lastTicketsAlert', {
                                                                ticketCount: remainingTickets
                                                            })}
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="sh-info-description" style={{ border: 'dashed' }}>
                                                        <div className='sh-event-time' style={{ fontSize: '16px', fontWeight: '500', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                                                            {getTranslation('lastTicketsAlert', {
                                                                ticketCount: remainingTickets
                                                            })}
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                            :
                                            <>
                                                <div className="sh-info-description" style={{ border: 'dashed' }}>
                                                    <div className='sh-event-time' style={{ fontSize: '16px', fontWeight: '500', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                                                        {getTranslation('ticketsNowOnSale')}
                                                    </div>
                                                </div>
                                            </>
                                        }

                                    </>
                                    :
                                    <>
                                        {Date.now() > (Number(eventDetails?.eventEndDateTime) * 1000)
                                            ?

                                            <div className="sh-info-description" style={{ border: 'dashed' }}>
                                                <div className='sh-event-time' style={{ fontSize: '16px', fontWeight: '500', marginTop: '5px' }}>
                                                    {getTranslation('eventEnded')}
                                                </div>
                                            </div>
                                            :
                                            <div className="sh-info-description" style={{ border: 'dashed' }}>
                                                <div className='sh-event-time' style={{ fontSize: '16px', fontWeight: '500', marginTop: '5px' }}>
                                                    {getTranslation('ticketsNotYetOnSale')}
                                                </div>
                                            </div>
                                        }

                                    </>
                                }
                            </>
                        }

                        {myTickets.length > 0 &&
                            <>
                                <div className="sh-info-description" style={{ height: 'fit-content', cursor: 'var(--pointer)' }} onClick={() => setActiveTab(getTranslation("myTickets"))}>
                                    <div style={{ position: 'relative', height: `${250 * 0.4 + (Math.min(myTickets.length, 5) - 1) * 2}px`, overflow: 'hidden' }}>
                                        {myTickets.slice(0, 5).map((ticket, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    position: 'absolute',
                                                    top: `${index * 2}px`,
                                                    left: `${index * 2}px`,
                                                    zIndex: myTickets.length - index,
                                                    transform: 'scale(0.4)',
                                                    transformOrigin: 'top left',
                                                    width: 'calc(100% / 0.4)',
                                                }}
                                            >
                                                <SHEventETicket
                                                    clickable={false}
                                                    ticket={ticket}
                                                    event={eventDetails}
                                                    coverImage={event?.cover}
                                                    style={{
                                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        }

                    </div>
                }


            </div >

            <AlertBox
                isOpen={showSureModal}
                title={getTranslation("checkoutConfirmation")}
                message={isMultiple ? getTranslation("confirmGetFreeTickets") : getTranslation("confirmGetFreeTicket")}
                onConfirm={() => completeFreeTicketsPurchase()}
                onCancel={() => setShowSureModal(false)}
                confirmText={getTranslation("yes")}
                cancelText={getTranslation("no")}
                type={"warning"}
            />

            <AlertBox
                isOpen={showSuccesModal}
                title={getTranslation("success")}
                message={isMultiple ? getTranslation("ticketsReservedSuccess") + ". " + getTranslation("checkEmailForTicketInfo") : getTranslation("ticketReservedSuccess") + ". " + getTranslation("checkEmailForTicketInfo")}
                onConfirm={() => {
                    setShowSuccesModal(false);
                    setActiveTab(getTranslation('details'));
                }}
                confirmText={getTranslation("close")}
                type={"success"}
            />
        </>
    );
}
